<style scoped>
.parent {
  position: relative;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.overlay-message {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 75%;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  color: white;
}
.block-icon-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0%;
  pointer-events: none;
  z-index: 1000;
  display: flex;
  align-items: center;
}
.keep-aspect-ratio {
  padding-bottom: 56.25%;
  position: relative;
}
.loading-wrapper {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
<template>

<div class="full-width">
  <div v-if="ready" class="parent full-width full-height" id="box" :style="watched ? {'min-height': '300px'} : {}">
    <quiz-overlay
      :currentTime="currentTime"
      :mediaId="media._id"
      v-if="!flagEditMode"
      />
    <subtitle-overlay
      :currentTime="currentTime"
      :mediaId="media._id"
      :subtitles="media.subtitles"
      :index="subtitleTrack"
      />
    <recommendation-overlay
      :channel="channel"
      :media="media"
      :currentTime="currentTime"
      v-if="playerState.state === 'ended' && media.type === 'video'"
      />
    <transition name="fade">
      <div class="overlay-message" v-if="flagTriggerComment">
        <div class="text-align-center full-width">{{$t('comment.paused')}}</div>
      </div>
    </transition>
    <video-player 
      :options="playerOptions"
      :subtitles="subtitles"
      :markers="markers"
      :thumbnails="thumbnails"
      :duration="media.duration"
      :startFrom="startFrom"
      @ready="onReady"
      @subtitle="onSubtitle"
      @time="onTimeUpdate"
      @playing="onPlaying"
      @paused="onPaused"
      @seek="onSeek"
      @ended="onEnded"
      @error="onError"
      />
    <div class="block-icon-wrapper" v-if="watched">
      <div class="text-align-center full-width">
        <mu-icon value="block" />
      </div>
    </div>
  </div>
  <div v-else class="keep-aspect-ratio">
    <div class="text-align-center loading-wrapper">
      <mu-circular-progress :size="72" />
    </div>
  </div>
</div>

</template>
<script>
// Event Bus
import {bus} from '@/main.js';
// Utils
import QuizOverlay from '@/components/Quiz/QuizOverlay.vue'
import SubtitleOverlay from '@/components/Overlay/SubtitleOverlay.vue'
import RecommendationOverlay from '@/components/Overlay/RecommendationOverlay.vue'

import VideoPlayer from '@/components/Common/VideoPlayer.vue'

// Library
import axios from "axios";
import mime from 'mime-types'

export default {
  name: 'VideoItem',
  components: { 
    VideoPlayer,
    QuizOverlay,
    SubtitleOverlay,
    RecommendationOverlay,
  },
  props: {
    channel: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    flagPauseSwitch: {
      type: Boolean,
      required: false
    },
    timestamp: {
      type: Number,
      required: false
    },
    flagEditMode: {
      type: Boolean
    },
    timestampTrigger: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      required: true
    },
    playerState: {
      type: Object,
      default() {
        return {}
      }
    },
    watched: {
      type: Boolean,
      default: false
    },
    startFrom: {
      type: String
    }
  },
  data() {
    return {
      // Flag
      flagTriggerComment: false, // Boolean variable for trigger from comment
      playerPausedByQuiz: false,
      
      reactions: [],
      sub: [],
      focus: "",

      // Video.js
      ready: false,
      playerOptions: { // Options for player
        controls: true,
        language: this.$i18n.locale(),
        playbackRates: [1.0, 1.5, 2.0],
        poster: this.thumbnailSource,
        sources: [{
          type: "",
          src: "",
        }],
        controlBar: {
          volumePanel: {
            inline: false
          },
          fullscreenToggle: true,
          progressControl: {
            seekBar: true
          }
        },
        aspectRatio: '16:9',
        fluid: true
      },
      state: "",
      subtitles: [],
      subtitleTrack: -1,
      thumbnails: [],
      markers: [],

      // Video Range
      videoRangeId: "",
      videoRangeTimeout: null
    }
  },
  computed: {
    // String
    stringSource() {
      return this.media.content;
    },
    thumbnailSource() {
      if(this.media.type == "video") {
        return this.media.thumbnail;
      } else if(this.media.type == "youtube") {
        if(this.media.thumbnail.includes('999.png')) {
          return this.media.thumbnail;
        } else {
          return this.stringThumbnailYoutube(this.media.thumbnail);
        }
      } else {
        return "";
      }
    },
    stringInitYoutube() {
      if(this.media.type === 'youtube') {
        return this.media.content;
     } else if(this.media.type == "mp4link") {
          return this.media.thumbnail;
      } else {
        return "";
      }
    },

    isNeedVideoStat() {
      return this.media.type === 'video' && !this.flagEditMode;
    },
    
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  watch: {
    flagPauseSwitch(newValue) {
      if (!this.state !== 'paused' && newValue && !this.flagTriggerComment) {
        this.playerPause();
        this.flagTriggerComment = true;
      }
      if (this.flagTriggerComment && !newValue) {
        this.playerPlay();
        this.flagTriggerComment = false;
      }
    },
    timestampTrigger(newValue) { // Watch on timestamp trigger
      if(!(this.media.hasOwnProperty('volatility') && this.media.volatility)) {
        this.playerCurrentTime(this.timestamp);
        if (this.state === 'paused') {
          this.playerPlay();
        }
      }
    },
    triggerRefresh() {
      this.fetchReactions();
    },
    focus(newValue) {
      this.$emit('onFocus', newValue);
    },
    media: {
      handler(newValue) {
        this.fetchReactions();
        this.$emit('onUpdateTime', 0);
      },
      deep: true
    },
  },
  mounted() {
    this.fetchReactions();
    if(this.watched) {
      this.$emit('onUpdateTime', this.media.duration);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  destroy() {
    window.removeEventListener('resize', this.onPlayerResized);
  },
  methods: {
    initPlayerOptions() {
      // Video type source check
      if(this.media.type === "video") {
        var type = mime.lookup(this.stringSource);
        if (type === "video/mp4") {
          this.playerOptions.sources[0].type = "video/mp4";
        }
        this.playerOptions.sources[0].src = this.stringSource;
        this.playerOptions.techOrder = ["html5"]
      } else if(this.media.type === "youtube") {
        this.playerOptions.sources[0].src = "//www.youtube.com/watch?v=" + this.media.content;
        this.playerOptions.sources[0].type = "video/youtube";
        this.playerOptions.techOrder = ["youtube"]
      } else if(this.media.type === "mp4link") {
        this.playerOptions.sources[0].type = "video/mp4";
        this.playerOptions.sources[0].src = this.media.content;
        this.playerOptions.techOrder = ["html5"]
      }
      
      // Video volatility check
      if(this.media.hasOwnProperty('volatility') && this.media.volatility) {
        this.playerOptions.controlBar.progressControl.seekBar = false;
        this.playerOptions.playbackRates = false;
      } else {
        this.playerOptions.controlBar.progressControl.seekBar = true;
        this.playerOptions.playbackRates = [1.0, 1.5, 2.0];
      }
      this.playerOptions.poster = this.thumbnailSource;
      
      // Initialize subtitles
      if(this.media.hasOwnProperty('subtitles') && Array.isArray(this.media.subtitles) && this.media.subtitles.length > 0) {
        this.subtitles = this.media.subtitles;
      } else {
        this.subtitles = [];
      }
      
      // Initialize minithumbnails
      if(this.media.hasOwnProperty('minithumbnail') && this.media.minithumbnail) {
        var arr = {};
        var i;
        for (i = 0; i < this.media.duration; i+=5) {
          arr[i] = {
            src: this.miniThumbnailSourceIndex(i/5)
          }
        }
        this.thumbnails = arr;
      } else {
        this.thumbnails = [];
      }
      
      // Initialize reactions markers
      if(!(this.media.hasOwnProperty('volatility') && this.media.volatility) && this.reactions.length > 0) {
        this.markers = this.reactions.map(i => { 
          return {
            key: i._id,
            time: i.timestamp, 
            timeEnd: i.timestampEnd, 
            text: (i.user.name ? i.user.name : i.user.username ) + ': ' + i.content, 
            color: "rgba(" + i.tag.backgroundColor.r + ", " + i.tag.backgroundColor.g + ", " + i.tag.backgroundColor.b + ", " + i.tag.backgroundColor.a + ")" 
          }
        });
      } else {
        this.markers = [];
      }
      
      this.ready = true;
    },
    // Fetch
    fetchReactions() {
      this.ready = false;
      
      axios.get(this.$store.getters.urlApi + "reaction/media/" + this.media._id + "/tag/list?filter=all", {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.reactions = response.data.data.reactions;
        this.initPlayerOptions();
      });
    },
    
    // Event
    onReady() {
      console.log('Player ready');
    },
    onSubtitle(index) {
      this.subtitleTrack = index;
    },
    onTimeUpdate(payload) {
      this.$emit('onUpdateTime', payload.time);
      if(this.isNeedVideoStat) {
        clearTimeout(this.videoRangeTimeout);
        this.videoRangeTimeout = setTimeout(() => {
          this.onUpdateVideoRange(payload.range);
        }, 500);
      }
    },
    onPlaying(payload) {
      this.state = 'playing';
      this.$emit('onPlayerState', {
        state: 'playing'
      });
      if(this.isNeedVideoStat) {
        this.onCreateVideoAction({
          action: 'play',
          timestamp: payload.time
        });
      }
    },
    onPaused(payload) {
      this.state = 'paused';
      this.$emit('onPlayerState', {
        state: 'paused'
      });
      if(this.isNeedVideoStat) {
        this.onCreateVideoAction({
          action: 'pause',
          timestamp: payload.time
        });
      }
    },
    onSeek(payload) {
      this.$emit('onPlayerState', {
        state: 'seeked'
      });
      if(this.isNeedVideoStat) {
        this.onCreateVideoAction({
          action: 'seek',
          start: payload.start,
          end: payload.to
        });
      }
    },
    onEnded(payload) {
      this.$emit('onPlayerState', {
        state: 'ended'
      });
      if(this.isNeedVideoStat) {
        this.onCreateVideoAction({
          action: 'end',
          timestamp: payload.time
        });
      }
    },
    onError(payload) {
      console.log(payload)
    },
    
    playerPause() {
      bus.$emit('pause');
    },
    playerPlay() {
      bus.$emit('play');
    },
    playerCurrentTime(time) {
      bus.$emit('setTime', time);
    },

    // Update Events
    onUpdateVideoRange(range) {
      var data = {
        'range': range
      };
      if(this.videoRangeId !== '') {
        data['id'] = this.videoRangeId;
      }
      axios.put(this.$store.getters.urlApi + "video/range/media/" + this.media._id, data, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      }).then(res => {
        this.videoRangeId = res.data.data.videoRange._id;
      });
    },
    onCreateVideoAction(data) {
      var body = JSON.stringify(data);
      axios.post(this.$store.getters.urlApi + "video/action/media/" + this.media._id, body, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      });
    },

    // String
    stringThumbnailYoutube(thumbnail) {
      return "//img.youtube.com/vi/" + this.media.content + "/" + thumbnail + ".jpg"
    },

    // String
    miniThumbnailSourceIndex(num) {
      if(this.media.hasOwnProperty('thumbnail') && typeof this.media.thumbnail === 'string') {
        var split = this.media.thumbnail.split('/');
        split.pop();
        return split.join('/') + '/t_' + num + '.jpg';
      } else {
        return "";
      }
    },

  },
}
</script>
